<template>
	<page-content bgClass="bg-#0E0E0E" :triggered="triggered" :more="more" needMore @scrolltolower="scrolltolower"
		@refresherpulling="refresherpulling">
		<template v-slot:navBar>
			<home-nav isHome></home-nav>
		</template>
		<template v-slot:content>
			<div class="pb-140">
				<div class="home-banner-bg-image pt-50 relative">
					<div class="flex items-center justify-center">
						<div class="flex items-center justify-center home-banner-text-bg-image">
							<span class="text-20 text-white">{{ $t('首页.轮播.标题') }}
								</span>
						</div>
					</div>
					<div class="mt-20 flex items-center justify-center">
						<span class="text-50 font-bold text-primary-gradient-1">{{ $t('首页.轮播.描述1') }}
							</span>
					</div>
					<div class="mt-10 flex items-center justify-center">
						<span class="text-50  font-bold text-primary-gradient-2">{{ $t('首页.轮播.描述2') }}
							</span>
					</div>
					<div class="absolute left-0 right-0 bottom-0 flex items-center justify-center pb-50">
						<div class="rounded-full w-650 h-100 bg-primary flex items-center justify-center" @click="goLp">
							<span class="text-32 text-white" v-if="show_address != ''">{{ show_address }}</span>
							<span class="text-32 text-white" v-else>{{ $t('公共.链接钱包') }}</span>
						</div>
					</div>
				</div>
				<div class="px-40">
					<div class="bg-white/10 rounded-20 p-30">
						<div class="flex items-center justify-center" @click="goSwap">
							<span class="text-24 text-primary">{{ $t('支持的网络') }}</span>
						</div>
						<div class="mt-40 relative h-50">
							<div class="h-54 mr-30 flex items-center overflow-x-auto px-20">
								<div v-for="(item, index) in chains" :key="index"
									class="flex-shrink-0 px-30 h-50 bg-primary/20 rounded-full border border-solid border-primary flex items-center justify-center mr-20">
									<span class="text-20 text-white">{{ item.name }}</span>
								</div>
<!--								<div-->
<!--									class="flex-shrink-0 px-30 h-50 bg-primary/20 rounded-full border border-solid border-primary flex items-center justify-center mr-20">-->
<!--									<span class="text-20 text-white">{{ $t('首页.企业绩效管理') }}</span>-->
<!--								</div>-->
<!--								<div-->
<!--									class="flex-shrink-0 px-30 h-50 bg-primary/20 rounded-full border border-solid border-primary flex items-center justify-center mr-20">-->
<!--									<span class="text-20 text-white">{{ $t('首页.仲裁委员会') }}</span>-->
<!--								</div>-->
<!--								<div-->
<!--									class="flex-shrink-0 px-30 h-50 bg-primary/20 rounded-full border border-solid border-primary flex items-center justify-center mr-20">-->
<!--									<span class="text-20 text-white">{{ $t('首页.仲裁委员会') }}</span>-->
<!--								</div>-->
							</div>
<!--							<div-->
<!--								class="absolute top-0 right-0 w-50 h-50 bg-primary/20 rounded-full border border-solid border-primary flex items-center justify-center">-->
<!--								<span class="text-20 text-white">+12</span>-->
<!--							</div>-->
						</div>
					</div>
				</div>
				<!-- 探索DApps -->
				<div class="mt-30 home-img_zs1-bg-image pt-76 px-40">
					<div class="">
						<span class="text-36 text-white">{{ $t('首页.探索DApps') }}</span>
					</div>
					<div class="mt-20">
						<span class="text-28 text-#eee">{{ $t('首页.发现去中心化应用程序') }}</span>
					</div>
					<div class="mt-30 flex items-center overflow-x-auto">
						<div @click="queryInfo.type = item.id" v-for="(item, index) in typeList" :key="index"
						:class="[item.id == queryInfo.type ? 'bg-white text-black' : 'bg-primary/10 text-white']"
						class="px-30 h-80 rounded-20 flex items-center justify-center mr-20  flex-shrink-0">
							<span class="text-26">{{$t(item.nameKey)}}</span>
						</div>
					</div>
					<div class="mt-30">
						<div @click="goToPage(item)" v-for="(item, index) in dappList" :key="index" class="home-item1Bg-image p-30 flex items-center mb-20">
							<div class="w-100 h-100 flex-shrink-0">
								<img class="w-full h-full" :src="item.thumbnail" alt="" />
							</div>
							<div class="ml-20 flex-1">
								<div class="flex items-center justify-between">
									<span class="text-36 text-white">{{item.title}}</span>
									<img class="w-32 h-32" src="@/assets/images/pages/home/gd.png" alt="" />
								</div>
								<div class="mt-20 w-480 text-ellipsis-1">
									<span class="text-20 text-#eee">{{item.synopsis}}</span>
								</div>
							</div>
						</div>
						<div class="mt-50 rounded-20 flex items-center justify-center bg-primary h-100">
							<span class="text-36 text-white font-bold">{{$t("首页.查看所有Dapps")}}</span>
							<img class="ml-20 w-30 h-26" src="@/assets/images/pages/home/ck.png" alt="" />
						</div>
					</div>
				</div>
				<!-- 战略合作伙伴 -->
				<div class="mt-30 home-img_bj2-bg-image pt-76 px-40">
					<div class="flex items-center justify-between">
						<div>
							<div class="">
								<span class="text-36 text-white">{{ $t('首页.战略合作伙伴') }}</span>
							</div>
							<div class="mt-20">
								<span class="text-28 text-#eee">{{ $t('首页.值得信赖的生态系统合作伙伴') }}</span>
							</div>
						</div>
						<div class="px-20 h-80 bg-white rounded-20 flex items-center justify-center">
							<span class="text-26 text-black">{{$t("首页.全部")}}</span>
						</div>
					</div>

					<div class="mt-30 flex flex-wrap justify-between">
						<div v-for="(item, index) in hzhbList" :key="index" class="home-item2Bg-image p-30 m-10 relative">
							<div class="flex items-center">
								<div class="w-58 h-58 flex-shrink-0">
									<img class="w-full h-full" :src="item.icon" alt="" />
								</div>
								<div class="ml-20">
									<span class="text-white text-32 font-bold">{{item.name}}</span>
								</div>
							</div>
                            <div class="">
                                <span class="text-20 text-#eee">{{$t(item.descKey)}}</span>
                            </div>
							<div class="absolute left-0 right-0 px-20 flex items-center justify-end" style="bottom: 20rem;">
                                <div v-for="(item2, index2) in item.tabs" :key="index2" class="rounded-6 bg-white/10 px-10 h-32 flex items-center justify-center">
                                    <span class="text-20 text-white">{{$t(item2)}}</span>
                                </div>
                            </div>
						</div>
					</div>
				</div>
				<!-- 最新消息 -->
				<div class="mt-30 home-img_bj4-bg-image pt-76 px-40">
					<div class="flex items-center justify-between">
						<div>
							<div class="">
								<span class="text-36 text-white">{{ $t('首页.最新消息') }}</span>
							</div>
							<div class="mt-20">
								<span class="text-28 text-#eee">{{ $t('首页.保持对Web3关注') }}</span>
							</div>
						</div>
						<div class="px-20 h-80 bg-white rounded-20 flex items-center justify-center">
							<span class="text-26 text-black">{{$t("首页.全部")}}</span>
						</div>
					</div>
					<div class="mt-30">
						<div v-for="(item, index) in newsList" :key="index" class="rounded-20 bg-white/10 mb-20" :class="[index == 0 ? '' : 'flex items-center p-30']" @click="goNotice(item)">
							<div :class="[index == 0 ? 'w-full h-300' : 'w-200 h-150']" class="flex-shrink-0">
								<img class="w-full h-full" style="object-fit: cover;" :src="item.thumbnail" alt="" />
							</div>
							<div class="flex-1 p-20">
								<div class="mt-20">
									<span class="text-30 text-white">{{item.title}}</span>
								</div>
								<div class="mt-40 flex items-center justify-between">
									<span class="text-20 text-#666">{{item.created_at}}</span>
									<img class="w-32 h-32" src="@/assets/images/pages/home/gd.png" alt="" />
								</div>
							</div>
						</div>
					</div>
					<div class="mt-30 bg-white/10 rounded-20 p-20">
						<div class="mt-30">
							<span class="text-36 font-bold text-white">{{$t("首页.官方频道")}}</span>
						</div>
						<div class="flex items-center flex-wrap mt-30">
                            <div v-for="(item, index) in gfpdList" :key="index" class="w-290 bg-white/10 rounded-20 m-10 p-30 flex items-center" @click="goToUrl(item.url)">
                                <div class="w-70 h-70 flex items-center">
                                    <img class="w-full h-full" :src="item.icon" alt="" />
                                </div>
                                <div class="ml-20">
                                    <div>
                                        <span class="text-28 text-white">{{$t(item.nameKey)}}</span>
                                    </div>
                                    <div class="mt-10">
                                        <span class="text-20 text-#eee">{{$t(item.descKey)}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
				</div>
				<div class="h-50rpx w-full">
					<span>1</span>
				</div>
			</div>
		</template>
		<template v-slot:menuBar>
			<!-- <menu-bar activeMenu="home"></menu-bar> -->
		</template>
		<template v-slot:popup>
			<!-- 设置上级弹窗  closeable -->
			<!-- <van-popup v-model="managerShow" round :style="{ width: '600rem', backgroundColor: '#09242C' }">
				<div class="flex items-center justify-center py-3">
					<span class="text-primary font-bold" style="font-size: 36rem;">{{ $t('弹窗.上级邀请码') }}</span>
				</div>
				<div class="flex items-center rounded-full my-4 mx-3 px-3"
					style="height: 100rem; background-color: rgba(245, 245, 245, .1);">
					<input class=" flex-1 text-white" style="font-size: 28rem;" type="text" v-model="invite"
						:placeholder="$t('弹窗.请输入邀请码')" />
				</div>
				<div class="flex items-center justify-center pb-4">
					<div class="flex items-center justify-center rounded-30 airdrop-item-btn-image mt-4 mx-3"
						@click="changeManager">
						<span class="text-32 font-bold">{{ $t('弹窗.确认') }}</span>
					</div>
				</div>
			</van-popup> -->
		</template>
	</page-content>
</template>

<script>
	import {
		ajaxData
	} from "@/request/ajax";
	import homeNav from '@/components/home-nav/home-nav.vue';
	import menuBar from '@/components/menu-bar/menu-bar.vue';
	import {
		getShowAddress,
		getToken,
		setShowAddress,
		setToken
	} from "@/libs/util";
	import Web3 from "web3";
	import router from "@/router";
	import utils from "@/utils/utils.js";
	import store from "@/store/index.js";

	export default {
		components: {
			homeNav,
			menuBar,
		},
		data() {
			return {
				triggered: false,
				more: 1,
				pool_total: 0,
				pool_release: 0,
				pool_destroy: 0,
				parent_id: 0,
				total_pledge: 0,
				dynamic_bouns: 0,
				state_bouns: 0,
				state_bouns_today: 0,
				team_one: 0,
				team_two: 0,
				team_three: 0,
				team_four: 0,
				tvl: "",
				mua: "",
				vip_name: "",
				address: "",
				manager: "",
				timer: null,
				web3Provider: null,
				web3: null,
				banner: [{}, {}, {}],
                chains: [],
				currency: [],
				stocks: [],
				rotation: [],
				new_title: "",
                show_address: "",
				new_id: "",
				next_vip_name: "",
				next_vip_number: "",
				last_update_time: "",
				invite: "",
				// 设置上级弹窗
				managerShow: false,
				typeList: [
					{
						id: 1,
						nameKey: "首页.全部"
					},
					{
						id: 2,
						nameKey: "首页.去中心化金融"
					},
					{
						id: 3,
						nameKey: "首页.非同质化代币"
					}
				],
				queryInfo: {
					type: 1,
				},
				dappList: [
					// {
					// 	id: 1,
					// 	icon: require("@/assets/images/pages/home/dapp1.png"),
					// 	name: "Opensea",
					// 	desc: "Opensea是全球第一个1和最大的web3 NFT...",
					// 	path: "swap"
					// },
					// {
					// 	id: 2,
					// 	icon: require("@/assets/images/pages/home/dapp2.png"),
					// 	name: "Relay",
					// 	desc: "Instant, low-cost bridging and swapping on a",
					// 	path: "lock"
					// },
					// {
					// 	id: 3,
					// 	icon: require("@/assets/images/pages/home/dapp3.png"),
					// 	name: "Hyperliquid",
					// 	desc: "Hyperliquid 是一个去中心化的永续期货交易所..",
					// 	path: "usdr-swap"
					// },
					// {
					// 	id: 4,
					// 	icon: require("@/assets/images/pages/home/dapp4.png"),
					// 	name: "Uniswap",
					// 	desc: "Uniswap 是基于以太坊链的去中心化自动做市商..",
					// },
					// {
					// 	id: 5,
					// 	icon: require("@/assets/images/pages/home/dapp5.png"),
					// 	name: "GMGN.AI",
					// 	desc: "更快发现 Meme 代币，跟随聪明钱赚取收益",
					// },
				],
                hzhbList: [
                    {
                        id: 1,
                        icon: require("@/assets/images/pages/home/hzhb1.png"),
                        name: "Solana",
                        descKey: "首页.合作伙伴.Solana.描述",
                        tabs: ['首页.标签.Defi']
                    },
                    {
                        id: 2,
                        icon: require("@/assets/images/pages/home/hzhb2.png"),
                        name: "CoinStats",
                        descKey: "首页.合作伙伴.CoinStats.描述",
                        tabs: ['首页.标签.Defi', '首页.标签.数据分析']
                    },
                    {
                        id: 3,
                        icon: require("@/assets/images/pages/home/hzhb3.png"),
                        name: "Shaga",
                        descKey: "首页.合作伙伴.Shaga.描述",
                        tabs: ['首页.标签.链游']
                    },
                    {
                        id: 4,
                        icon: require("@/assets/images/pages/home/hzhb4.png"),
                        name: "Grass",
                        descKey: "首页.合作伙伴.Grass.描述",
                        tabs: ['首页.标签.其他']
                    },
                    {
                        id: 5,
                        icon: require("@/assets/images/pages/home/hzhb5.png"),
                        name: "Jupiter",
                        descKey: "首页.合作伙伴.Jupiter.描述",
                        tabs: ['首页.标签.DEX']
                    },
                    {
                        id: 6,
                        icon: require("@/assets/images/pages/home/hzhb6.png"),
                        name: "boop.fun",
                        descKey: "首页.合作伙伴.boop.fun.描述",
                        tabs: ['首页.标签.其他']
                    },

                ],
				newsList: [
					// {
					// 	id: 1,
					// 	img: require("@/assets/images/pages/home/new1.png"),
					// 	title: "新的跨链桥在5个网络上推出",
					// 	time: "2小时前"
					// },
					// {
					// 	id: 2,
					// 	img: require("@/assets/images/pages/home/new2.png"),
					// 	title: "去中心化金融(DeFi)TVL 达到历史最高水平..",
					// 	time: "2小时前"
					// },
					// {
					// 	id: 3,
					// 	img: require("@/assets/images/pages/home/new3.png"),
					// 	title: "主要协议完成安全审计",
					// 	time: "2小时前"
					// }
				],
                gfpdList: [
                    {
                        id: 1,
                        nameKey: "首页.官方频道.推特.名称",
                        url: "https://x.com/RoonChain",
                        icon: require("@/assets/images/pages/home/gfpd1.png"),
                        descKey: "首页.官方频道.推特.描述"
                    },
                    {
                        id: 2,
                        nameKey: "首页.官方频道.Discord.名称",
                        url: "https://discord.gg/roonchain",
                        icon: require("@/assets/images/pages/home/gfpd2.png"),
                        descKey: "首页.官方频道.Discord.描述"
                    },
                    {
                        id: 3,
                        nameKey: "首页.官方频道.电报.名称",
                        url: "https://t.me/roonchainchat",
                        icon: require("@/assets/images/pages/home/gfpd3.png"),
                        descKey: "首页.官方频道.电报.描述"
                    },
                    {
                        id: 4,
                        nameKey: "首页.官方频道.RoonChain.官网",
                        url: "https://roonchain.com/",
                        icon: require("@/assets/images/pages/home/gfpd5.png"),
                        descKey: "首页.官方频道.RoonChain.描述"
                    }
                ]
			};
		},
		computed: {},
		created() {
			let vm = this
			vm.invite = router.currentRoute.query.invite || "";
			if (window.ethereum) {
				vm.web3Provider = window.ethereum
				vm.web3 = new Web3(vm.web3Provider);

				vm.enable()
			} else {
				vm.$message.error(utils.$t("吐司.请在钱包中打包"))
			}
		},
		methods: {
			goToPage(item) {
                if (item.jump_type == 1){
                    this.$router.push({
                        path: '/' + item.jump_url
                    })
                }else if(item.jump_type == 2){
                    window.open(item.jump_url, '_blank')
                }else{
                    this.$message.success("暂未开放")
                }
			},
			goToUrl(url) {
                if (url == ""){
                    return ;
                }
				window.open(url, '_blank')
			},
			// 2. 路径对象
			goToTouzi() {
				this.$router.push({
					path: '/investment'
				})
			},
            goLp() {
                this.$router.push({
                    path: '/destroy-mining'
                })
            },
            goSwap() {
                this.$router.push({
                    path: '/staking'
                })
            },
			goToIncome() {
				this.$router.push({
					path: '/income'
				})
			},
			goNotice(item) {
				router.push({
					path: '/news-details',
					query: {
						id: item.id,
					}
				})
			},
			zwkf() {
				this.$message.success(utils.$t("吐司.暂未开放"))
			},
			goUrl(url) {
				window.location.href = url
			},
			enable() {
				let vm = this
				vm.web3Provider.enable() //如果用户拒绝了登录请求
					.catch(function(reason) {
						console.log("reason")
						if (reason === 'User rejected provider access') {
							vm.$message.error(utils.$t("吐司.用户拒绝提供程序访问"))
						} else {
							// 本不该执行到这里，但是真到这里了，说明发生了意外
							vm.$message.error(utils.$t("吐司.请刷新重试"))
						}
					})
					//如果用户同意了登录请求，你就可以拿到用户的账号
					.then(function(accounts) {
						console.log("-----")
						// alert(ethereum.selectedAddress)
						// You also should verify the user is on the correct network:
						//你也可以验证用户接入了正确的网络
						if (vm.web3Provider.networkVersion !== vm.desiredNetwork) {
							// layer_msg('请选择正确的网络.')
							//我们计划在最近补充一个有关网络切换的API，参考下面链接
							// https://github.com/MetaMask/metamask-extension/issues/3663
						}
						//一旦获取了用户账号，你就可以签名交易
						console.log(accounts)

						vm.address = vm.web3Provider.selectedAddress

						vm.address = vm.address.toLowerCase()

						console.log("selectaddress:" + vm.address)
						let token = getToken()
						// setToken("")
						// token = false
						if (token == false) {
							vm.web3.eth.personal.sign(vm.web3.utils.utf8ToHex("login"), vm.address, (err, sign) => {
								if (err) {
									vm.$message.error(err);
								} else {
									console.log(vm.address)

									ajaxData("/register", {
										address: sign,
										invite: vm.invite,
									}).then(response => {
										console.log(response)
										setToken(response.data.token)
										vm.getIndex()
									})
									// }else {
									//     vm.getIndex()
									// }

								}
							})
						} else {
							vm.getIndex()
						}
					})
			},
			showLanguageSelect() {
				this.$refs.languageSelectRef.open();
			},
			goairdrop() {
				utils.reToPage('airdrop');
			},
			changeManager() {
				let vm = this
				if (vm.manager == "") {
					vm.$message(utils.$t("吐司.请输入邀请码"))
					return false
				}
				// vm.web3.eth.personal.sign(vm.web3.utils.utf8ToHex("password"), vm.address, (err, sign) => {
				// 	if (err) {
				// 		vm.$message.error(err);
				// 	} else {
				// 		console.log(vm.address)

				ajaxData("/user/bind", {
					invitation_code: vm.invite,
				}).then(response => {
					vm.managerShow = false
					vm.$message(utils.$t("吐司.操作成功"))
					vm.parent_id = response.data.parent_id
					console.log(response)
					console.log(vm.parent_id)
				})
				// }
				// })

			},
			getIndex() {
				let vm = this
				getShowAddress()
				ajaxData("/v2/index", {}).then(response => {
					vm.currency = response.data.currency
					vm.parent_id = response.data.parent_id
					vm.new_title = response.data.new_title
					vm.new_id = response.data.new_id
					vm.chains = response.data.chains
					vm.dappList = response.data.dapps
					vm.newsList = response.data.news

					vm.show_address = response.data.show_address

					setShowAddress(response.data.show_address)


					if (response.data.address != vm.address) {
						setToken("")
						vm.enable()
					}

				})
			},
			scrolltolower() {
				console.log("滚动到底部/右边");
				this.triggered = true;
				setTimeout(() => {
					this.more = 0;
					this.triggered = false;
				}, 1000)
			},
			getRandomInt(min, max) {
				min = Math.ceil(min);
				max = Math.floor(max);
				return Math.floor(Math.random() * (max - min + 1)) + min;
			},
			refresherpulling() {
				this.triggered = true;
				setTimeout(() => {
					this.triggered = false;
				}, 200)
				console.log("下拉刷新");
			}
		},
	};
</script>

<style scoped>
	.home-banner-bg-image {
		width: 750rem;
		height: 1036rem;
		background-image: url("~@/assets/images/pages/home/bannerBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.home-banner-text-bg-image {
		width: 490rem;
		height: 70rem;
		background-image: url("~@/assets/images/pages/home/bannerTextBg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.home-img_zs1-bg-image {
		background-image: url("~@/assets/images/pages/home/img_zs1.png");
		background-size: 676rem 344rem;
		background-repeat: no-repeat;
		background-position: top right;
	}

	.home-item1Bg-image {
		width: 670rem;
		height: 168rem;
		background-image: url("~@/assets/images/pages/home/item1Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.home-img_bj2-bg-image {
		background-image: url("~@/assets/images/pages/home/img_bj2.png");
		background-size: 490rem 174rem;
		background-repeat: no-repeat;
		background-position: top right;
	}

	.home-item2Bg-image {
		width: 312rem;
		height: 300rem;
		background-image: url("~@/assets/images/pages/home/item2Bg.png");
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: top center;
	}

	.home-img_bj4-bg-image {
		background-image: url("~@/assets/images/pages/home/img_bj4.png");
		background-size: 530rem 220rem;
		background-repeat: no-repeat;
		background-position: top right;
	}


</style>
